import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { InputPicker } from "rsuite";
import {
  FormDatePicker,
  FormRadioGroup,
  FormDropDownList,
  FormMaskedTextBox,
  FormMaskedTextBoxMobile,
  FormRadioGroupStatus,
} from "@mikros/shared-ui";
import { DateInput } from "@progress/kendo-react-dateinputs";
import { useState } from "react";
import ApiServices from "../../../service/apiService";
import { NewUser } from "@mikros/library";
import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Confirm } from "@mikros/shared-ui";
import { FormattedMessage, useIntl } from "react-intl";
import { Alert } from "@mikros/shared-ui";
import { UpdateUser } from "@mikros/library/src/model";
import countryCodes, { CountryProperty } from "country-codes-list";
import "react-phone-input-2/lib/style.css";
import { Error } from "@progress/kendo-react-labels";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import { useNavigate } from "react-router-dom";

export interface CreateUserProps {
  // gridItems: any;
  createState: Function;
  searchState: Function;
  createUserFormData?: Function;
  dataGridItems?: any;
  formType?: string;
  formTypeFunction: Function;
  fetchDataBeforeState?: Boolean;
  refreshDataReference?: any;
  updateDataRef?: any;
  // hasMoreDataReference?: any;
  hasMoreData?: Boolean;
  hasMoreDataFunction?: Function;
}

export function CreateUser(props: CreateUserProps) {
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const empIDRegex: RegExp = /^[a-zA-Z0-9\s.-]+$/;
  const navigate = useNavigate();

  console.log("error instance in create user", errorInstance.errorCode);

  const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/);
  const mobileRegex: RegExp = new RegExp(/^[0-9]{5,15}$/);
  const mobileRegexUpdate: RegExp = /^(\+[0-9]{5,20})$/;

  const nameRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.,_/&\-#()]+$/);
  const workRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.,_/&#${}()\-\[\]]+$/);

  console.log(
    "props last working date",
    props.dataGridItems?.dataIems?.lastWorkingDate
  );
  console.log(
    "gender print",
    props.dataGridItems?.dataItems?.userProfile?.gender
  );
  console.log("props date of join", props.dataGridItems?.dataItem?.dateOfJoin);
  const validators = {
    mobileNumberValidator: (value: string) =>
      !value
        ? ""
        : mobileRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.mobileNumberValidation",
          })}`,
    mobileNumberUpdateValidator: (value: string) =>
      !value
        ? ""
        : mobileRegexUpdate.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.mobileNumberAnotherValidation",
          })}`,
    empIdValidator: (value: string) =>
      !value
        ? ""
        : empIDRegex.test(value)
        ? ""
        : `${intl.formatMessage({ id: "user.createUser.empIdValidation" })}`,
    firstNameValidator: (value: string) =>
      !value
        ? `${intl.formatMessage({ id: "user.createUser.fnameValidation" })}`
        : nameRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.fnameAnotherValidation",
          })}`,
    lastNameValidator: (value: string) =>
      !value
        ? `${intl.formatMessage({ id: "user.createUser.lnameValidation" })}`
        : nameRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.lnameAnotherValidation",
          })}`,
    otp: (value: string) => (!value ? "Enter 6 digit OTP" : ""),
    emailValidator: (value: string) =>
      !value
        ? ""
        : emailRegex.test(value)
        ? ""
        : `${intl.formatMessage({ id: "user.createUser.emailValidation" })}`,
    deptRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.departmentValidation",
          })}`,
    desgRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.designationValidation",
          })}`,
    branchRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({ id: "user.createUser.branchValidation" })}`,
    locationRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({ id: "user.createUser.locationValidation" })}`,

    eid: (value: string) =>
      !value ? intl.formatMessage({ id: "users.createUser.employeeId" }) : "",
    mnum: (value: string) =>
      !value
        ? intl.formatMessage({ id: "organization.mobileNumberValidation" })
        : mobileRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "users.createUser.validPhoneNumber" }),
    doj: (value: DateInput) =>
      !value
        ? // "Select date of Joining"
          intl.formatMessage({ id: "users.createUser.selectDateOfJoin" })
        : "",
    dob: (value: DateInput) =>
      !value
        ? intl.formatMessage({ id: "users.createUser.selectDateOfBirth" })
        : "",
    lastWorkingDate: (value: DateInput) =>
      !value ? intl.formatMessage({ id: "" }) : "",
    status: (value: Button) =>
      !value
        ? intl.formatMessage({ id: "users.createUser.chooseAppropriateOption" })
        : "",
    gender: (value: Button) =>
      !value
        ? // "Choose an appropriate option"
          intl.formatMessage({ id: "users.createUser.chooseAppropriateOption" })
        : "",

    // role: (value: DropDownButton) => !value ? "Please choose a value from dropdown for role" : "",
    lang: (value: string) =>
      !value
        ? // "Please choose a value from dropdown for language"
          intl.formatMessage({ id: "users.createUser.chooseLanguage" })
        : "",

    fname: (value: string) =>
      !value
        ? //  "Please enter first Name"
          intl.formatMessage({ id: "user.createUser.fnameValidation" })
        : "",
    lname: (value: string) =>
      !value
        ? intl.formatMessage({ id: "user.createUser.lnameValidation" })
        : "",
    dept: (value: string) =>
      !value
        ? intl.formatMessage({ id: "user.createUser.departmentValidation" })
        : "",
    desg: (value: string) =>
      !value
        ? intl.formatMessage({ id: "user.createUser.designationValidation" })
        : "",
    loc: (value: string) =>
      !value
        ? intl.formatMessage({ id: "user.createUser.locationValidation" })
        : "",
    branch: (value: string) =>
      !value
        ? intl.formatMessage({ id: "user.createUser.branchValidation" })
        : "",
  };
  const phoneNumber = props.dataGridItems?.dataItems?.phNo;

  console.log(
    "props data grid items in create user",
    props?.dataGridItems?.dataItem?.email
  );
  console.log("props grid items in create user", props.dataGridItems);
  console.log("Test empId", empIDRegex.test("-"));
  const countries = [
    { label: "India", value: "+91", code: "in" },
    { label: "Singapore", value: "+65", code: "sg" },
    { label: "Malaysia", value: "+60", code: "my" },
  ];

  const intl = useIntl();

  const [showInitialValues, setShowInitialValues] = useState<any>({});
  // const myCountryCodesObject = countryCodes?.customList(
  //   CountryProperty?.countryCode,
  //   "[{countryCode}] {countryNameEn}: +{countryCallingCode}"
  // );
  const myCountryCodesObject = countryCodes?.customList(
    "countryCode",
    "[{countryCode}] {countryNameEn}: +{countryCallingCode}"
  );
  const myCountryCodesArray = Object.entries(myCountryCodesObject).map(
    ([key, value]) => value
  );

  console.log("my country code object", myCountryCodesObject);
  console.log("myCountryCodesArray", myCountryCodesArray);

  console.log(
    "account id instance in tenant side outside adfafladfk",
    accountInstance.accntId
  );

  const extractedData = myCountryCodesArray.map((item: any) => {
    const [countryCodeSome, rest] = item.split("]");
    const [countryNameEn, countryCallingCode] = rest.split(": +");

    console.log("print country code adsfaf", countryCodeSome);
    console.log("print rest", rest);

    console.log("print country name english", countryNameEn);
    console.log("print country calling code", countryCallingCode);

    return {
      countryCode: countryCodeSome.slice(1),
      countryNameEn,
      item,
      countryCallingCode: `+${countryCallingCode}`,
    };
  });

  const countryList = extractedData.map((item) => {
    return {
      label: item.item,
      value: item.item,
      code: item.countryCode.toLowerCase(),
      countryName: item.countryNameEn,
      countryCallingCode: item.countryCallingCode,
    };
  });

  console.log("print country list 13224", countryList);

  const data = [
    "Eugenia",
    "Bryan",
    "Linda",
    "Nancy",
    "Lloyd",
    "Alice",
    "Julia",
    "Albert",
  ].map((item) => ({ label: item, value: item }));
  const defaultCountryCode = "+91";

  console.log("extracted data", extractedData);

  const [formKey, setFormKey] = React.useState(1);

  const [user, setUser] = useState<NewUser>({
    userProfile: {},
    auditDetails: {},
  } as NewUser);

  const [upadateUser, setUpdateUser] = useState<UpdateUser>({
    auditDetails: {},
  } as UpdateUser);

  const [countryCode, setCountryCode] = useState<any>();

  const [formDialog, setformDialog] = React.useState<boolean>(false);
  const [clearDialog, setclearDialog] = React.useState<boolean>(false);
  const [empIdDialog, setEmpIdDialog] = React.useState<boolean>(false);
  const [emailOrMobile, setEmailOrMobile] = React.useState<boolean>(false);
  const [dupemail, setDupEmail] = React.useState<boolean>(false);
  const [dupphone, setDupPhone] = React.useState<boolean>(false);
  const [organizationChannel, setOrganizationChannel] = React.useState<any>();

  const [errors, setErrors] = useState<any>({});
  const [enterError, setEnterError] = useState<boolean>(false);

  console.log("organization details", organizationChannel);
  console.log(
    "organization channel whatsapp",
    organizationChannel?.distbAcc?.whatsApp?.enabled
  );
  console.log(
    "organization channel teams",
    organizationChannel?.distbAcc?.teams?.enabled
  );

  const emptyAuditDetails = {
    ratings: [],
    comments: "",
    obtainedMarks: 0,
  };

  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  console.log("error code flag value print", errorFlag);
  console.log("Updated error code: outside adsadffd", errorInstance.errorCode);

  console.log("please print country code error", errors);
  console.log("enter error", enterError);
  console.log("country code print", countryCode);

  console.log("print form dialog", formDialog);

  const formKeyChange = () => {
    setFormKey(formKey + 1);
    setErrors({});
  };

  const CustomMobileLabel = () => (
    <div>
      <span>
        <FormattedMessage id="user.createUser.mobile"></FormattedMessage>
      </span>
      <span className="text-[10px] italic">
        {/* (including country code) */}
        <FormattedMessage id="user.createUser.countryCode"></FormattedMessage>
      </span>
    </div>
  );

  const toggleformDialog = () => {
    setformDialog(!formDialog);
  };
  const toggleEmpIdDialog = () => {
    setEmpIdDialog(!empIdDialog);
  };
  const toggleEmailOrMobileDialog = () => {
    setEmailOrMobile(!emailOrMobile);
  };

  // const toggleDupEmail = () => {
  //   setDupEmail(!dupemail);
  // };
  // const toggleDupPhone = () => {
  //   setDupPhone(!dupphone);
  // };

  const [phoneNumberStore, setPhoneNumberStore] = useState<Number>();

  console.log(
    "initial values in create user form to be displayed in form",
    showInitialValues
  );
  console.log(
    "print data grid items in create user screen",
    props.dataGridItems
  );
  console.log("status print", props.dataGridItems?.dataItems?.status);
  console.log("gender print", props.dataGridItems?.dataItems?.gender);

  async function signIn(formData: { [name: string]: any }) {
    console.log("phone number store", phoneNumberStore);
    console.log("form data mobile number initial", formData["mobileNumber"]);

    if (props.formType === "NEW") {
      console.log("inside new props");
      let data = user;
      data.accntId = accountInstance.accntId;
      data.branchCd = "branch001";
      data.branchName = formData["branch"];
      data.createdBy = "admin";
      data.date = "2023-05-08";
      data.dateOfJoin = formData["dateOfJoin"];
      data.department = formData["department"];
      data.empId = formData["eid"];
      data.group = "department_level_group_subGroup";
      data.groupIndex = "";
      data.level = "department_level_group";
      data.levelIndex = "";
      data.subGroup = "subG";
      data.location = formData["location"];
      data.prefrdLanguage =
        formData["language"] ===
        intl.formatMessage({ id: "user.createUser.selectLanguage" })
          ? ""
          : formData["language"];
      data.subGroupIndex = "";
      data.tenantName = "CakeBee";
      data.updatedBy = formData["role"];
      data.designation = formData["designation"];
      data.description = "";
      data.status = formData["status"];

      data.userProfile.dob = formData["dateOfBirth"];
      data.lastWorkingDate = formData["lastWorkingDate"];
      data.email = formData["emailId"];
      data.userProfile.firstName = formData["firstName"];
      data.userProfile.gender = formData["gender"];
      data.userProfile.lastName = formData["lastName"];
      data.auditDetails = emptyAuditDetails;

      console.log("country code print inside data", countryCode);

      const countryCodeIndex = countryCode?.lastIndexOf(":");
      const countryCodeNumber = countryCode
        ?.substring(countryCodeIndex + 1)
        ?.trim();

      console.log("country code number", countryCodeNumber);
      data.phNo =
        countryCodeNumber && countryCodeNumber + formData["mobileNumber"];

      // data.userProfile.phNo = formData["mobileNumber"]
      //   ? countryCodeNumber && countryCodeNumber + formData["mobileNumber"]
      //   : "";
      console.log("first name print", formData["firstName"]);
      console.log(
        "please enter mobile number field data",
        formData["mobileNumber"]
      );
      console.log("form data email print", formData["emailId"]),
        console.log("phone number print in create user", data.phNo);

      // if (!countryCodeNumber && formData["mobileNumber"] !== undefined) {
      if (!countryCodeNumber && formData["mobileNumber"]?.trim()) {
        console.log("inside undefined of country code");
        let err: any = {};
        err.noCountryCode = {
          error: intl.formatMessage({ id: "users.createUser.countryCode" }),
        };
        setErrors(err);

        return false;
      }
      if (countryCodeNumber && !formData["mobileNumber"]?.trim()) {
        console.log("inside undefined of mobile number");
        let err: any = {};
        err.noMobileNumber = {
          error: intl.formatMessage({ id: "users.createUser.mobileNumber" }),
        };
        setErrors(err);
        return false;
      }
      console.log("form entry data", data);
      console.log("form entry data json", JSON.stringify(data));
      console.log("branch name in signIn", data.branchName);
      console.log("in create user");

      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(`${accountInstance.accntId}/user`, "POST", data)
          .then(async (data) => {
            if (data && data.errorMessage) {
              console.log(
                "I entered error code handling in users error code",
                data
              );
              setErrorFlag(true);
              await errorInstance.updateErrorCode(data.errorMessage);
              return;
            } else {
              toggleformDialog();
              // formData["mobileNumber"] = "";
              // data.userProfile.phNo = "";
            }

            console.log("print the error message", data.errorMessage);
          });
      }
      return true;
    } else if (props.formType === "EDIT") {
      let updatedData = upadateUser;
      console.log("update user print", updatedData);

      updatedData.dob = formData["dateOfBirth"];
      updatedData.lastWorkingDate = formData["lastWorkingDate"];
      updatedData.email = formData["emailId"];
      updatedData.firstName = formData["firstName"];
      updatedData.gender = formData["gender"];
      updatedData.lastName = formData["lastName"];
      updatedData.phNo = formData["mobileNumber"];
      updatedData.accntId = accountInstance.accntId;
      updatedData.branchName = formData["branch"];
      updatedData.dateOfJoin = formData["dateOfJoin"];
      updatedData.department = formData["department"];
      updatedData.empId = formData["eid"];
      updatedData.location = formData["location"];
      // updatedData.prefrdLanguage = formData["language"];
      updatedData.prefrdLanguage =
        formData["language"] ===
        intl.formatMessage({ id: "user.createUser.selectLanguage" })
          ? ""
          : formData["language"];
      updatedData.designation = formData["designation"];
      updatedData.status = formData["status"];
      updatedData.role = formData["role"];
      updatedData.userId = props.dataGridItems.dataItems.userId;
      updatedData.auditDetails = props.dataGridItems.dataItems.auditDetails
        ? props.dataGridItems.dataItems.auditDetails
        : emptyAuditDetails;

      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(`${accountInstance.accntId}/user`, "PUT", updatedData)
          .then(async (updatedData) => {
            if (updatedData && updatedData.errorMessage) {
              console.log(
                "inside error message in update user data print pleasseeee",
                updatedData
              );
              console.log(
                "inside error message in update user",
                updatedData.errorMessage
              );
              setErrorFlag(true);
              await errorInstance.updateErrorCode(updatedData.errorMessage);
              return;
            } else {
              toggleformDialog();
            }
            console.log(
              "print the error message in update user",
              updatedData.errorMessage
            );
          });
      }
      return true;
    }
  }

  React.useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  return (
    <div>
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                // navigate("/home");
                navigate("/users");
              } else {
                navigate("/users");
              }
            }}
          />
        </Dialog>
      )}

      <div className="text-mk-primary-bright text-xl font-bold">
        {props.formType === "NEW" ? (
          <FormattedMessage id="createUser.title" />
        ) : (
          <FormattedMessage id="createUser.updateUser.title" />
        )}
      </div>

      {empIdDialog && (
        <Dialog className="errorDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "users.createUser.empIdDup",
            })}`}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              toggleEmpIdDialog();
            }}
          />
        </Dialog>
      )}
      {emailOrMobile && (
        <Dialog className="errorDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "users.createUser.emailOrMobile",
            })}`}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              toggleEmailOrMobileDialog();
            }}
          />
        </Dialog>
      )}

      {/* {dupemail && (
        <Dialog className="errorDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "users.createUser.dupEmail",
            })}`}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              toggleDupEmail();
            }}
          />
        </Dialog>
      )}*/}

      {/*dupphone && (
        <Dialog className="errorDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "users.createUser.dupPhone",
            })}`}
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              toggleDupPhone();
            }}
          />
        </Dialog>
      )*/}

      {props.createState && (
        <div className="mt-2">
          <Form
            initialValues={
              props.formType === "EDIT"
                ? {
                    eid: props.dataGridItems?.dataItems?.empId,
                    firstName:
                      props.dataGridItems?.dataItems?.userProfile?.firstName,
                    lastName:
                      props.dataGridItems?.dataItems?.userProfile?.lastName,
                    emailId: props.dataGridItems?.dataItems?.email,
                    mobileNumber:
                      props.dataGridItems?.dataItems?.phNo === "N/A"
                        ? ""
                        : props.dataGridItems?.dataItems?.phNo,
                    dateOfJoin: props.dataGridItems?.dataItems?.dateOfJoin,
                    status:
                      props.dataGridItems?.dataItems?.status === "ACTIVE"
                        ? "enabled"
                        : "disabled",

                    // gender:
                    //   props.dataGridItems?.dataItems?.userProfile?.gender ===
                    //   "MALE"
                    //     ? "Male"
                    //     : "Female",
                    gender: props.dataGridItems?.dataItems?.userProfile?.gender,
                    // language: props.dataGridItems?.dataItems?.prefrdLanguage,
                    language:
                      props.dataGridItems?.dataItems?.prefrdLanguage?.trim()
                        ? props.dataGridItems.dataItems.prefrdLanguage
                        : intl.formatMessage({
                            id: "user.createUser.selectLanguage",
                          }),

                    department: props.dataGridItems?.dataItems?.department,
                    designation: props.dataGridItems?.dataItems?.designation,
                    location: props.dataGridItems?.dataItems?.location,
                    branch: props.dataGridItems?.dataItems?.branchName,
                    dateOfBirth:
                      props.dataGridItems?.dataItems?.userProfile?.dob,
                    lastWorkingDate:
                      props.dataGridItems?.dataItems?.lastWorkingDate,
                  }
                : {
                    eid: "",
                    firstName: "",
                    lastName: "",
                    emailId: "",
                    mobileNumber: "",
                    dateOfJoin: "",
                    status: "enabled",
                    gender: "",
                    // language: intl.formatMessage({ id: "language.english" }),
                    language: intl.formatMessage({
                      id: "user.createUser.selectLanguage",
                    }),
                    department: "",
                    designation: "",
                    location: "",
                    branch: "",
                    dateOfBirth: "",
                    lastWorkingDate: "",
                    // props.dataGridItems?.dataIems?.lastWorkingDate,
                  }
            }
            onSubmit={signIn}
            key={formKey}
            render={(formRenderProps) => (
              <FormElement>
                <div className="grid grid-cols-2">
                  <div>
                    <div>
                      <Field
                        name={"eid"}
                        id={"eid"}
                        label={<FormattedMessage id="user.createUser.empId" />}
                        component={FormMaskedTextBox}
                        validator={validators.empIdValidator}
                        className="bg-white w-96"
                        maxLength={20}
                      />
                    </div>

                    <div>
                      <Field
                        name={"firstName"}
                        id={"firstName"}
                        label={<FormattedMessage id="user.createUser.fname" />}
                        maxLength={50}
                        component={FormMaskedTextBox}
                        validator={validators.firstNameValidator}
                        className="bg-white w-96"
                      />
                    </div>

                    <div>
                      <Field
                        name={"lastName"}
                        id={"lastName"}
                        label={<FormattedMessage id="user.createUser.lname" />}
                        maxLength={50}
                        component={FormMaskedTextBox}
                        validator={validators.lastNameValidator}
                        className="bg-white w-96"
                      />
                    </div>
                    <div>
                      <Field
                        name={"emailId"}
                        id={"emailId"}
                        label={
                          <FormattedMessage id="user.createUser.emailId" />
                        }
                        maxLength={50}
                        component={FormMaskedTextBox}
                        validator={validators.emailValidator}
                        className="bg-white w-96"
                      />
                    </div>

                    {props.formType === "NEW" ? (
                      <div>
                        <div className="flex items-end">
                          <InputPicker
                            cleanable={false}
                            size="sm"
                            // style={{ width: 102 }}
                            style={{
                              width: 102,
                              display: "inline-block",
                              border: "1px solid var(--color-mk-primary)",
                              borderRadius: "4px",
                            }}
                            className="bg-white w-96"
                            onChange={setCountryCode}
                            // @ts-ignore
                            data={countryList}
                            renderValue={(value, item: any) => {
                              return (
                                <div className="bg-white w-96">
                                  <span
                                    className={`fi fi-${item?.code}`}
                                  ></span>
                                  {item?.countryCallingCode}
                                </div>
                              );
                            }}
                            renderMenuItem={(label, item) => {
                              const code = item?.code?.toLowerCase();
                              return (
                                <div>
                                  <p></p>
                                  <span
                                    className={`fi fi-${item?.code}`}
                                  ></span>
                                  &nbsp;
                                  {`${item?.countryName} (${item?.countryCallingCode})`}
                                </div>
                              );
                            }}
                          />

                          <Field
                            name={"mobileNumber"}
                            id={"mobileNumber"}
                            label={<CustomMobileLabel />}
                            maxLength={15}
                            component={FormMaskedTextBoxMobile}
                            validator={validators.mobileNumberValidator}
                            className="bg-white w-72"
                          />
                        </div>
                        <Error>{errors.noCountryCode?.error}</Error>
                        <Error>{errors.noMobileNumber?.error}</Error>
                      </div>
                    ) : (
                      <Field
                        name={"mobileNumber"}
                        id={"mobileNumber"}
                        label={
                          <FormattedMessage id="searchUser.mobileNumber" />
                        }
                        maxLength={15}
                        component={FormMaskedTextBox}
                        validator={validators.mobileNumberUpdateValidator}
                        className="bg-white w-96"
                      />
                    )}

                    <div>
                      <Field
                        name={"dateOfJoin"}
                        id={"dateOfJoin"}
                        label={
                          <FormattedMessage id="user.createUser.dateOfJoin" />
                        }
                        component={FormDatePicker}
                        max={new Date()}
                        className="bg-white w-40"
                      />
                    </div>

                    <div>
                      <Field
                        name={"lastWorkingDate"}
                        id={"lastWorkingDate"}
                        label={
                          <FormattedMessage id="user.createUser.lastWorkingDate" />
                        }
                        component={FormDatePicker}
                        className="bg-white w-40"
                        //  min={ props.dataGridItems?.dataItems?.status === "ACTIVE"?new Date():undefined}//allow only today and future dates if active
                        //  max={props.dataGridItems?.dataItems?.status=== "INACTIVE"?new Date():undefined}//allow only today and past dates if inactive
                        // min={new Date()}

                        min={new Date()}
                      />
                    </div>

                    <div>
                      <Field
                        name={"dateOfBirth"}
                        id={"dateOfBirth"}
                        label={
                          <FormattedMessage id="user.createUser.dateOfBirth" />
                        }
                        component={FormDatePicker}
                        className="bg-white w-40"
                        max={new Date()}
                      />
                    </div>

                    <div className="flex relative items-center justify-between">
                      <Field
                        name="status"
                        id="status"
                        label={<FormattedMessage id="user.createUser.status" />}
                        component={FormRadioGroupStatus}
                        layout="horizontal"
                        data={[
                          {
                            label: intl.formatMessage({
                              id: "personal.enabled",
                            }),
                            value: "enabled",
                          },
                          {
                            label: intl.formatMessage({
                              id: "personal.disabled",
                            }),
                            value: "disabled",
                          },
                        ]}
                        className="flex"
                        defaultValue="enabled"
                      />
                    </div>

                    <div className="flex relative items-center justify-between">
                      <Field
                        name={"gender"}
                        id={"gender"}
                        label={<FormattedMessage id="user.createUser.gender" />}
                        component={FormRadioGroup}
                        layout="horizontal"
                        data={[
                          {
                            label: intl.formatMessage({ id: "maleLang" }),
                            value: "Male",
                          },
                          {
                            label: intl.formatMessage({ id: "femaleLang" }),
                            value: "Female",
                          },
                          {
                            label: intl.formatMessage({ id: "otherLang" }),
                            value: "Other",
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div>
                    <div></div>
                    <div>
                      <Field
                        name={"language"}
                        id={"language"}
                        label={
                          <FormattedMessage id="user.createUser.language" />
                        }
                        component={FormDropDownList}
                        className="bg-mk-primary-15 w-96"
                        validator={validators.lang}
                        data={[
                          intl.formatMessage({ id: "language.english" }),
                          intl.formatMessage({ id: "language.hindi" }),
                          intl.formatMessage({ id: "language.tamil" }),
                        ]}
                      />
                    </div>
                    <div>
                      <Field
                        name={"department"}
                        id={"department"}
                        label={<FormattedMessage id="user.createUser.dept" />}
                        maxLength={30}
                        component={FormMaskedTextBox}
                        validator={validators.deptRegexValidator}
                        className="bg-white w-96"
                      />
                    </div>

                    <div>
                      <Field
                        name={"designation"}
                        id={"designation"}
                        label={<FormattedMessage id="user.createUser.desg" />}
                        maxLength={30}
                        component={FormMaskedTextBox}
                        validator={validators.desgRegexValidator}
                        className="bg-white w-96"
                      />
                    </div>

                    <div>
                      <Field
                        name={"location"}
                        id={"location"}
                        label={<FormattedMessage id="user.createUser.loc" />}
                        maxLength={30}
                        component={FormMaskedTextBox}
                        validator={validators.locationRegexValidator}
                        className="bg-white w-96"
                      />
                    </div>

                    <div>
                      <Field
                        name={"branch"}
                        id={"branch"}
                        label={<FormattedMessage id="user.createUser.branch" />}
                        maxLength={30}
                        component={FormMaskedTextBox}
                        validator={validators.branchRegexValidator}
                        className="bg-white w-96"
                      />
                    </div>

                    <div className="flex mt-4 gap-4 justify-start">
                      {props.formType === "NEW"
                        ? formDialog && (
                            <Dialog className="confirmSuccessDialogue">
                              <Confirm
                                description={`${intl.formatMessage({
                                  id: "users.createUser.newUser",
                                })}`}
                                successText={`${intl.formatMessage({
                                  id: "users.buttonText.Ok",
                                })}`}
                                failureText={`${intl.formatMessage({
                                  id: "users.createUser.anotherUser",
                                })}`}
                                icon={"successShape.png"}
                                iconMsg={intl.formatMessage({
                                  id: "iconMsgSuccess",
                                })}
                                backgroundColor={"mk-bright-green"}
                                onSuccess={() => {
                                  props.searchState(true);
                                  props.createState(false);
                                }}
                                onFailure={() => {
                                  toggleformDialog();
                                  setFormKey(formKey + 1);
                                  setErrors({});
                                  setCountryCode("");
                                }}
                              />
                            </Dialog>
                          )
                        : formDialog && (
                            <Dialog className="confirmSuccessDialogue">
                              <Alert
                                description={`${intl.formatMessage({
                                  id: "users.createUser.updateUser",
                                })}`}
                                buttonText={`${intl.formatMessage({
                                  id: "users.buttonText.Ok",
                                })}`}
                                icon={"successShape.png"}
                                iconMsg={intl.formatMessage({
                                  id: "iconMsgSuccess",
                                })}
                                backgroundColor={"mk-bright-green"}
                                onClick={() => {
                                  props.searchState(true);
                                  props.createState(false);
                                  props.formTypeFunction(false);
                                }}
                              />
                            </Dialog>
                          )}

                      <Button
                        className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                                        hover:text-black focus:outline-none px-4 py-2"
                        onClick={() => {
                          props.refreshDataReference.current = true;
                          // props.updateDataRef.current = true;
                        }}
                      >
                        {props.formType === "NEW" ? (
                          <FormattedMessage id="user.createUser.submit"></FormattedMessage>
                        ) : (
                          <FormattedMessage id="user.createUser.update"></FormattedMessage>
                        )}
                      </Button>

                      {props.formType === "NEW" ? (
                        <div className="flex gap-4">
                          <div>
                            <Button
                              key={formKey}
                              onClick={formKeyChange}
                              className="rounded-lg bg-mk-light-grey text-black hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
                            >
                              <FormattedMessage id="user.createUser.clear"></FormattedMessage>
                            </Button>
                          </div>
                          <div>
                            <Button
                              onClick={() => {
                                props.searchState(true);
                                props.createState(false);
                                props.refreshDataReference.current = false;
                                if (props.hasMoreDataFunction) {
                                  props.hasMoreDataFunction(true);
                                }
                              }}
                              className="rounded-lg bg-mk-light-grey text-black hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
                            >
                              <FormattedMessage id="backButton"></FormattedMessage>
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <Button
                          onClick={() => {
                            props.searchState(true);
                            props.createState(false);
                            props.refreshDataReference.current = false;
                            if (props.hasMoreDataFunction) {
                              props.hasMoreDataFunction(true);
                            }
                          }}
                          className="rounded-lg bg-mk-light-grey text-black hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
                        >
                          <FormattedMessage id="backButton"></FormattedMessage>
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </FormElement>
            )}
          />
        </div>
      )}
    </div>
  );
}
